import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function Medias({
  mediaTypes,
  handleChangeMediaSelect,
  value,
}) {
  const classes = useStyles();
  return (
    <FormControl className={classes.formControl}>
      <InputLabel id="demo-simple-select-label">メディア</InputLabel>
      <Select
        value={value}
        onChange={(event) => {
          handleChangeMediaSelect(event.target.value);
        }}
      >
        <MenuItem value={"null"}>全て</MenuItem>
        {mediaTypes.map((mediaType) => {
          return (<MenuItem key={mediaType.id} value={mediaType.id}>{mediaType.label}</MenuItem>)
        })}
      </Select>
    </FormControl>
  );
}
